<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <div class="col-12 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle d-block">Lista</span>
        <h3 class="page-title d-inline">Serviços</h3>
        <d-link class="btn btn-success text-white float-right " :to="{ name: 'admin-service-new' }">Novo serviço</d-link>
      </div>
    </d-row>

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="card-small mb-4">
          <div class="card-header border-bottom d-flex justify-content-around">
            <div class="col-6">
              <h6 class="m-0">Serviço Ativos</h6>
            </div>
            <div class="col-6">
              <form class="main-sidebar__search w-100 d-flex">
                <div class="input-group input-group-seamless ml-3">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i class="fas fa-search"></i>
                    </div>
                  </div>
                  <input
                    class="navbar-search form-control"
                    type="text"
                    placeholder="Procurar por algo..."
                    aria-label="Search"
                    v-model="pagination.search"
                  >
                </div>
              </form>
            </div>
          </div>
          <div class="card-body p-0 pb-3 text-left">
            <div class="table-overflow">
              <EntityTable
                :items="services.list"
                edit-route-name="admin-service-edit"
                edit-param-key="serviceId"
                delete-event="DELETE_SERVICE"
                modal-title="Confirme exclusão de serviço"
                modal-message="Tem certeza que deseja excluir esse serviço?"
                :cancel-delete="close"
                :confirm-delete="deleteRow"
                @select-item-to-delete="handleSelect"
              />
            </div>
            <pagination :total-items="services.total_items" :pagination.sync="pagination"></pagination>
          </div>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Pagination from '_shared/Pagination.vue';
import EntityTable from '_common/ui/EntityTable.vue';
import EntityDeleteMixin from '_common/mixins/EntityDeleteMixin';
import { _DELETE_SERVICE_ } from '../components/ServiceModel';

export default {
  name: 'service-list',
  components: {
    Pagination,
    EntityTable,
  },
  mixins: [EntityDeleteMixin],
  data() {
    return {
      pagination: {
        search: '',
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
        slug: 'service',
      },
      selectedObject: null,
      DELETE_SERVICE: _DELETE_SERVICE_,
      redirectPath: '/admin/servicos/lista/1',
      successMessage: 'Serviço deletado com sucesso',
      emitEvent: 'update:pagination',
    };
  },
  computed: {
    services() {
      const { serviceList } = this.$store.state.service;
      if (serviceList && serviceList.list.length) {
        return serviceList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
  },
  watch: {
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getServiceList',
    ]),
    getList() {
      this.setToggle({ type: 'progress', bool: true });
      this.getServiceList(this.pagination)
        .then(() => {
          this.setToggle({ type: 'progress', bool: false });
        });
    },
    handleSelect(itemId) {
      this.selectedObject = itemId;
    },
  },
  mounted() {
    Events.$emit('sidebarVisible', false);
    Events.$on('update:pagination', pagination => {
      this.$router.push({ params: { page: pagination.page } });
      this.getList();
    });
    this.getList();
  },
  beforeDestroy() {
    Events.$off('update:pagination');
  },
};
</script>

<style lang="scss" scoped>
</style>
